(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5113],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(60713);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(53432);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(68919);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(86288);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js

function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js


const _excluded = ["className", "raised"];











const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};

const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });

  const {
    className,
    raised = false
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 40320:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/app/entrepreneur",
      function () {
        return __webpack_require__(10853);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);





var Typewriter = function(param) {
    var input = param.input, renderText = param.renderText, _styleOverPropsForCursor = param.styleOverPropsForCursor, styleOverPropsForCursor = _styleOverPropsForCursor === void 0 ? {} : _styleOverPropsForCursor, _styleOverPropsForText = param.styleOverPropsForText, styleOverPropsForText = _styleOverPropsForText === void 0 ? {} : _styleOverPropsForText, _hideCursor = param.hideCursor, hideCursor = _hideCursor === void 0 ? false : _hideCursor, _speed = param.speed, speed = _speed === void 0 ? 20 : _speed;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), text = ref[0], setText = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), index = ref1[0], setIndex = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), showCursor = ref2[0], setShowCursor = ref2[1];
    var speedForCursor = speed * 25;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timerID = setInterval(function() {
            if (index < input.length) {
                setText(function(prevText) {
                    return prevText + input[index];
                });
                setIndex(function(prevIndex) {
                    return prevIndex + 1;
                });
            } else {
                clearInterval(timerID);
            }
        }, speed);
        return function() {
            return clearInterval(timerID);
        };
    }, [
        input,
        index,
        speed
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timerID = setInterval(function() {
            setShowCursor(function(prevShowCursor) {
                return !prevShowCursor;
            });
        }, speedForCursor);
        return function() {
            return clearInterval(timerID);
        };
    }, [
        speedForCursor
    ]);
    var ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                variant: "body2",
                sx: {
                    color: "common.white",
                    whiteSpace: "pre-line"
                }
            }, styleOverPropsForText), {
                children: (ref3 = renderText === null || renderText === void 0 ? void 0 : renderText(text)) !== null && ref3 !== void 0 ? ref3 : text
            })),
            hideCursor ? null : text.length !== input.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, styleOverPropsForCursor), {
                variant: "body2",
                style: {
                    opacity: showCursor ? 1 : 0
                },
                children: "|"
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Typewriter);


/***/ }),

/***/ 10853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Entrepreneur; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40549);
/* harmony import */ var _layouts_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72575);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61582);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _theme_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78187);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(3180);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41997);
/* harmony import */ var _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98968);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(31812);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var ts_enum_util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54586);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25168);
/* harmony import */ var _sections_landing_Shares__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29608);
/* harmony import */ var _services_prompts_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76271);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _components_Typewriter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77645);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(13135);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  min-height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

















Entrepreneur.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layouts_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
var MoneyWishToSpendMap;
(function(MoneyWishToSpendMap) {
    MoneyWishToSpendMap["u_1000"] = "1000 USD";
    MoneyWishToSpendMap["u_2000"] = "2000 USD";
    MoneyWishToSpendMap["u_3000"] = "3000 USD";
    MoneyWishToSpendMap["u_4000"] = "4000 USD";
    MoneyWishToSpendMap["u_5000"] = "5000 USD";
    MoneyWishToSpendMap["u_6000"] = "6000 USD";
    MoneyWishToSpendMap["u_7000"] = "7000 USD";
    MoneyWishToSpendMap["u_8000"] = "8000 USD";
    MoneyWishToSpendMap["u_9000"] = "9000 USD";
})(MoneyWishToSpendMap || (MoneyWishToSpendMap = {}));
var StyledCard = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_templateObject(), _theme_palette__WEBPACK_IMPORTED_MODULE_5__/* .shinyCssWithoutHoverEffect */ .PM);
var __N_SSG = true;
function Entrepreneur(param) {
    var title = param.title, prompts = param.prompts, globalSetting = param.globalSetting, seoMetadataItemsCollection = param.seoMetadataItemsCollection;
    var ref, ref1;
    var _items;
    var targetPromptEngineering = lodash_find__WEBPACK_IMPORTED_MODULE_4___default()((_items = globalSetting === null || globalSetting === void 0 ? void 0 : globalSetting.promptEngineeringsCollection.items) !== null && _items !== void 0 ? _items : [], {
        purpose: "entrepreneur"
    });
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .useVisitorGeneratePromptLazyQuery */ .SDW)({
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "no-cache"
    }), 2), visitorGeneratePromptLazyQuery = ref2[0], ref3 = ref2[1], visitorGeneratePromptLazyQueryLoading = ref3.loading, visitorGeneratePromptLazyQueryData = ref3.data;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)();
    var _language;
    var searchString = {
        language: (_language = router.query.language) !== null && _language !== void 0 ? _language : _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_6__/* .PromptSupportingLanguageMap.English */ .aN.English
    };
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(searchString.language), selectLanguage = ref4[0], setSelectLanguage = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(MoneyWishToSpendMap.u_1000), moneyWishToSpend = ref5[0], setMoneyWishToSpend = ref5[1];
    var renderText = (ref1 = (ref = visitorGeneratePromptLazyQueryData === null || visitorGeneratePromptLazyQueryData === void 0 ? void 0 : visitorGeneratePromptLazyQueryData.generatePrompt.createResponse) === null || ref === void 0 ? void 0 : ref.choices[0]) === null || ref1 === void 0 ? void 0 : ref1.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: title !== null && title !== void 0 ? title : "",
        metadataItems: seoMetadataItemsCollection,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_sections_landing_Shares__WEBPACK_IMPORTED_MODULE_10__/* .RootStyle */ .i, {
            theme: theme,
            backgroundColor: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCard, {
                    sx: {
                        p: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            sx: {
                                mb: 3
                            },
                            color: "primary",
                            variant: "h3",
                            children: "Entrepreneur Only!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Typewriter__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            hideCursor: true,
                            styleOverPropsForText: {
                                sx: {
                                    color: "common.white"
                                },
                                variant: "body1"
                            },
                            speed: 8,
                            input: "Tell Us how much money wish to spend and AI will generate a business idea for you and make as much money as you want."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            container: true,
                            spacing: 4,
                            sx: {
                                pt: 4,
                                pb: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        disablePortal: true,
                                        id: "language",
                                        value: (0,_services_prompts_utils__WEBPACK_IMPORTED_MODULE_11__/* .languageTransformer */ .uj)(selectLanguage),
                                        options: (0,ts_enum_util__WEBPACK_IMPORTED_MODULE_8__/* .$enum */ .o6)(_generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_6__/* .PromptSupportingLanguageMap */ .aN).getValues().map(function(language) {
                                            return (0,_services_prompts_utils__WEBPACK_IMPORTED_MODULE_11__/* .languageTransformer */ .uj)(language);
                                        }),
                                        fullWidth: true,
                                        renderInput: function(params) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, params), {
                                                label: "Output Language",
                                                helperText: "Currently Supporting ".concat((0,ts_enum_util__WEBPACK_IMPORTED_MODULE_8__/* .$enum */ .o6)(_generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_6__/* .PromptSupportingLanguageMap */ .aN).getValues().length, " languages")
                                            }));
                                        },
                                        onChange: function(_event, values) {
                                            var ref;
                                            setSelectLanguage((ref = values === null || values === void 0 ? void 0 : values.id) !== null && ref !== void 0 ? ref : _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_6__/* .PromptSupportingLanguageMap.English */ .aN.English);
                                        },
                                        getOptionLabel: function(option) {
                                            return option.label;
                                        },
                                        isOptionEqualToValue: function(option, value) {
                                            return option.id === value.id;
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        disablePortal: true,
                                        id: "money spend",
                                        value: moneyWishToSpend,
                                        options: (0,ts_enum_util__WEBPACK_IMPORTED_MODULE_8__/* .$enum */ .o6)(MoneyWishToSpendMap).getValues(),
                                        fullWidth: true,
                                        renderInput: function(params) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, params), {
                                                label: "Money wish to spend",
                                                helperText: "Currently Only Supporting ".concat((0,ts_enum_util__WEBPACK_IMPORTED_MODULE_8__/* .$enum */ .o6)(MoneyWishToSpendMap).getValues().length, " options")
                                            }));
                                        },
                                        onChange: function(_event, values) {
                                            setMoneyWishToSpend(values !== null && values !== void 0 ? values : MoneyWishToSpendMap.u_1000);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                        variant: "outlined",
                                        fullWidth: true,
                                        size: "large",
                                        loading: visitorGeneratePromptLazyQueryLoading,
                                        onClick: function() {
                                            return visitorGeneratePromptLazyQuery({
                                                variables: {
                                                    promptId: "entrepreneur_making_as_much_money_as_possible",
                                                    language: selectLanguage,
                                                    prompt: moneyWishToSpend
                                                },
                                                fetchPolicy: "no-cache",
                                                context: targetPromptEngineering && targetPromptEngineering.sys && targetPromptEngineering.sys.id ? {
                                                    headers: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({}, _utils_constants__WEBPACK_IMPORTED_MODULE_27__/* .SHARED_PROMPT_HEADER_FOR_CUSTOM_PROMPT_ENGINEERING */ .r, targetPromptEngineering.sys.id)
                                                } : {}
                                            });
                                        },
                                        children: "Ask!"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: visitorGeneratePromptLazyQueryData && renderText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Typewriter__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        input: renderText
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 13135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ SHARED_PROMPT_HEADER_FOR_HERO_SECTION; },
/* harmony export */   "r": function() { return /* binding */ SHARED_PROMPT_HEADER_FOR_CUSTOM_PROMPT_ENGINEERING; }
/* harmony export */ });
var SHARED_PROMPT_HEADER_FOR_HERO_SECTION = "sections-minimals-hero-id";
var SHARED_PROMPT_HEADER_FOR_CUSTOM_PROMPT_ENGINEERING = "sections-special-engineering-id";


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6547,513,9694,1664,9463,7952,4894,1997,5609,6993,8424,6755,3907,2575,69,9774,2888,179], function() { return __webpack_exec__(40320); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);